import { apiClient } from './authService';

export const buildDownloadUrl = (path, query = {}) => {
  if (!path) {
    return null;
  }

  const baseUrl = apiClient.defaults.baseURL || '';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const url = new URL(
    `${baseUrl}${normalizedPath}`,
    typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
  );

  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    url.searchParams.set(key, String(value));
  });

  return url.toString();
};

